var map = {
	"./button-active.svg": "ac49",
	"./button.svg": "848d",
	"./defaultIcon.svg": "1825",
	"./lightbox-active.svg": "de09",
	"./lightbox.svg": "a475",
	"./panel-active.svg": "8e57",
	"./panel.svg": "0948",
	"./preview-click.svg": "e78b",
	"./safari-active.svg": "5479",
	"./safari.svg": "f125",
	"./standard-active.svg": "f326",
	"./standard.svg": "e4ea"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "67df";